import React, { useContext } from "react";
import axios from "axios";
import { Link, useLocation, useHistory } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { useTranslation } from "react-i18next";
import AuthContext from "../contexts/AuthContext";
import { menuItems, publicMenuItems, matchHref, getModeCounterpart } from "./headers/MainHeader";
import { prefetchUrl, getDefaultTabUrl } from "../utils/tabPrefetch";
import useAxios from "../utils/useAxios";
// Compact Table temporarily disabled - see ThemeContext.js.
// import { useTheme } from "../contexts/ThemeContext";

const BottomNav = () => {
    const { user } = useContext(AuthContext);
    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation();
    const authedApi = useAxios();
    // Compact Table temporarily disabled - see ThemeContext.js.
    // const { compactTable, setCompactTable } = useTheme();
    const isAdminMode = location.pathname.startsWith("/admin");
    const isAdminItems = user && isAdminMode;
    const items = isAdminItems ? menuItems : publicMenuItems;
    // the public nav items (e.g. "Клуби") land on a page that fetches with
    // a plain, unauthenticated axios call (see ClubsList.js) - prefetching
    // that same URL with the logged-in user's JWT attached instead got the
    // backend to scope ?all=true down to just their own club, and the
    // shared-by-URL prefetch cache (tabPrefetch.js) then handed that
    // wrongly-scoped response straight to the real page
    const prefetchApi = isAdminItems ? authedApi : axios;
    const modeCounterpart = user ? getModeCounterpart(location.pathname) : null;
    // Best-effort href (middle-click/open-in-new-tab); see goToModeCounterpart
    // below for why the real navigation can't just rely on this.
    const modeCounterpartHref = modeCounterpart ? `${modeCounterpart}${location.search}` : modeCounterpart;
    // TournamentsList.js writes its filter chips into the URL via a raw
    // window.history.replaceState call (not react-router's own history), so
    // react-router's location.search above quietly falls behind the real
    // address bar the moment a filter changes - a href built from it goes
    // stale. Reading window.location.search fresh at click time is the only
    // way to actually carry the current filters across the mode switch (see
    // Header.js's matching comment).
    const goToModeCounterpart = (e) => {
        if (!modeCounterpart) return;
        e.preventDefault();
        history.push(`${modeCounterpart}${window.location.search}`);
    };

    return (
        <nav className="site-bottom-nav">
            <div className="site-bottom-nav-row">
                <ul className="site-bottom-nav-pinned">
                    {modeCounterpart && (
                        <li className="mode-switch">
                            <Link to={modeCounterpartHref} onClick={goToModeCounterpart}>
                                <FeatherIcon icon={isAdminMode ? "edit" : "eye"} size={20} />
                                <span>{t(isAdminMode ? "Admin" : "Public View")}</span>
                            </Link>
                        </li>
                    )}
                    {/* User-facing-only density preference - an admin on their own
                        /admin/* list has no use for it, only the Public View of the
                        same list does (see TournamentsList.js/ClubsList.js/etc.'s own
                        compactTable && !is_authorized gate).
                        Compact Table temporarily disabled - see ThemeContext.js.
                    {!isAdminMode && (
                        <li className="compact-switch">
                            <button type="button" onClick={() => setCompactTable(!compactTable)}>
                                <FeatherIcon icon={compactTable ? "maximize-2" : "minimize-2"} size={20} />
                                <span>{compactTable ? t("Compact") : t("Standard mode")}</span>
                            </button>
                        </li>
                    )} */}
                </ul>
                <ul className="site-bottom-nav-scroll">
                    {items.map((item) => (
                        <li key={item.href} className={matchHref(location, item.href) ? "active" : ""}>
                            <Link
                                to={item.href}
                                onPointerDown={() => prefetchUrl(prefetchApi, getDefaultTabUrl(item.href))}
                            >
                                <FeatherIcon icon={item.icon} size={20} />
                                <span>{t(item.key)}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </nav>
    );
};

export default BottomNav;
